import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function PublicKeyList({match}) {

    const {t} = useTranslation();

    const fields = [
        {name: t('Key Id'), key: 'keyId'},
        {name: t('Country'), key: 'countryName'},
        {name: t('Purpose'), key: 'purpose', map:t},
        {name: t('Creation timestamp'), key: 'creationTimestamp', map: dateTimeFormatter},
        {name: t('Expiration timestamp'), key: 'expirationTimestamp', map: dateTimeFormatter},
        {name: t('User'), key: 'recordUserName'},
        {name: t('Status'), key: 'status', map:t},
    ];

    return (
        <ListCRUD
            plural='communicationPublicKeys'
            singular='communicationPublicKey'
            fields={fields}
            match={match}
            disableViewButton
            disableNewButton
            disableEditButton
        />
    );
};